import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import classNames from 'classnames'
import AuthContext from 'context/AuthContext'
import SubscriptionPlan from './SubscriptionPlan'

const tabBtnClass = 'ml-3 inline-block py-3 px-2 text-md xl:text-sm font-semibold border-b-2'
const tabActiveClass = 'border-lime-500 text-lime-500'
const tabBorderNoneClass = 'border-transparent'
const TAB_BASIC = 'Basic'
const TAB_STANDARD = 'Standard'
const TAB_GOLD = 'Gold'

function Subscription () {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'subscription_manager') ?? {}
  const [name, setName] = useState('Basic')
  const handleTabClick = (action, e) => {
    setName(action)
  }
  return (
    <div>
      <>
        <div className='pb-3'>
          <ul className='border-b flex'>
            <li className='mr-0'>
              <button
                onClick={handleTabClick.bind(this, TAB_BASIC)}
                className={classNames({
                  [tabBtnClass]: true,
                  [tabActiveClass]: name === TAB_BASIC,
                  [tabBorderNoneClass]: name !== TAB_BASIC
                })}
              >
                {t('O_BASIC')}
              </button>
            </li>
            <li className='mx-0'>
              <button
                onClick={handleTabClick.bind(this, TAB_STANDARD)}
                className={classNames({
                  [tabBtnClass]: true,
                  [tabActiveClass]: name === TAB_STANDARD,
                  [tabBorderNoneClass]: name !== TAB_STANDARD
                })}
              >
                {t('O_STANDARD')}
              </button>
            </li>
            <li className='mx-0'>
              <button
                onClick={handleTabClick.bind(this, TAB_GOLD)}
                className={classNames({
                  [tabBtnClass]: true,
                  [tabActiveClass]: name === TAB_GOLD,
                  [tabBorderNoneClass]: name !== TAB_GOLD
                })}
              >
                {t('O_GOLD')}
              </button>
            </li>
          </ul>
        </div>

        {name === TAB_BASIC
          ? (<SubscriptionPlan manager={manager} name={name} />)
          : name === TAB_STANDARD
            ? (<SubscriptionPlan name={name} manager={manager} />)
            : name === TAB_GOLD
              ? (<SubscriptionPlan name={name} manager={manager}/>)
              : null}
      </>
    </div>
  )
}

export default Subscription
